// Restore default-open menu-card accordions each time the mobile menu drawer opens.
//
// header-drawer.js `reset()` strips `[open]` from ALL nested <details> when the drawer closes, so
// menu-card accordions marked open_by_default (data-open-default) come back collapsed on the 2nd+
// open. On iOS Safari that collapsed-but-inconsistent state renders as a blank/limbo expanded card
// (the "sub-links disappear on second open" bug). Re-applying `open` when the drawer opens returns
// them to their intended default state and forces a repaint. Loaded unconditionally with the drawer
// (not gated by the search setting), so it always runs.
if (!window.__archiesMenuAccordionRestore) {
  window.__archiesMenuAccordionRestore = true;

  const wire = () => {
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return false;

    const restore = () => {
      if (!drawer.classList.contains('menu-open')) return;
      drawer
        .querySelectorAll('.menu-card-ext__details[data-open-default]:not([open])')
        .forEach((details) => {
          details.open = true;
        });

      // Restore the active group-tabs panel (the drawer's Women's/Men's menu-card switcher). A cart-mutation
      // Section-Rendering morph of the header re-renders the drawer and drops the JS-applied
      // `.tab-active-content-xx` from the active `.tab-id-*` panel, so EVERY panel collapses to display:none
      // and all Women's/Men's menu cards vanish (the drawer opened card-less after add→remove→open-burger).
      // tabs-ext.js only activates panels once at load, so nothing recovered it. Re-apply the class for each
      // group-tabs' active button — mirrors tabs-ext.js init (its lines 30-36). Idempotent (skips if already set).
      drawer.querySelectorAll('.group-tabs-parent').forEach((groupBlock) => {
        const activeButton =
          groupBlock.querySelector('.group-tab-btn-xx.tab-btn-active-xx') ||
          groupBlock.querySelector('.group-tab-btn-xx');
        const attr = activeButton && activeButton.getAttribute('data-btn');
        if (!attr) return;
        const panel = groupBlock.querySelector(
          '.tab-id-' + (window.CSS && CSS.escape ? CSS.escape(attr) : attr)
        );
        if (panel && !panel.classList.contains('tab-active-content-xx')) {
          panel.classList.add('tab-active-content-xx');
        }
      });
    };

    new MutationObserver(restore).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    restore();
    return true;
  };

  if (!wire()) {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  }
}
